import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import _ from 'lodash';
import Dialog from '../../../components/Dialog';
import Text from '../../../components/Text';
import { AutoCompleteSelect } from '../../../components';
import { TV_DASHBOARD_COLOR_ENUM } from '../../../comm/constant';
import { equipmentAPI } from '../../../apis';

const EditColorPopup = ({ handleSearch, handleClose }) => {
  const [list, setList] = useState([]);

  const getDashboardColorList = async () => {
    try {
      const { result } = await equipmentAPI.getDashboardColorList();
      setList(
        _.map(result, (item) => ({
          ...item,
          color: item.color ?? 'Default',
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDashboardColorList();
  }, []);

  const colorOptions = _.map(TV_DASHBOARD_COLOR_ENUM, (item) => ({
    text: item.title,
    value: item.title,
    color: item.dropDownColor,
    borderColor: item.dropDownBorderColor,
  }));

  const handleUpdateColor = (categoryId) => (value) => {
    setList((prevList) =>
      _.map(prevList, (item) => ({
        ...item,
        color: item.categoryId === categoryId ? value : item.color,
      }))
    );
  };

  const handleSubmit = async () => {
    try {
      const params = {
        clrs: _.map(list, (item) => ({
          categoryId: item.categoryId,
          color: item.color,
        })),
      };
      await equipmentAPI.updateDashboardColorList(params);
      handleClose();
      handleSearch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog
      open={true}
      title="Edit Equipment Category Color"
      cancel="Cancel"
      confirm="Update"
      dialogfootStyle={{ marginTop: '1.25rem', paddingTop: '1.56rem', boxShadow: '0px -1px 0px 0px #E4E7EB' }}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
    >
      <Box display="grid" gridTemplateColumns="1fr 1fr">
        <Box borderBottom="solid 1px #E6E7E8" pb="1.25rem" pl="0.62rem">
          <Text color="#538FFF" fontSize="1rem" fontWeight="700" textTransform="uppercase">
            Request ID
          </Text>
        </Box>
        <Box borderBottom="solid 1px #E6E7E8" pb="1.25rem">
          <Text color="#538FFF" fontSize="1rem" fontWeight="700" textTransform="uppercase">
            color
          </Text>
        </Box>
        {list.map((item) => (
          <React.Fragment key={item.categoryId}>
            <Box height="5.5rem" borderBottom="solid 1px #E6E7E8" display="flex" alignItems="center" pl="1.31rem">
              <Text color="#2E4469" fontSize="1rem">
                {item.categoryName}
              </Text>
            </Box>
            <Box height="5.5rem" borderBottom="solid 1px #E6E7E8" display="flex" alignItems="center">
              <AutoCompleteSelect
                type="color"
                width="13.75rem"
                height="3.5rem"
                itemList={colorOptions}
                value={item.color}
                onChange={handleUpdateColor(item.categoryId)}
                colorIconBorder={_.get(
                  _.find(TV_DASHBOARD_COLOR_ENUM, (colorItem) => colorItem.title === item.color),
                  'dropDownBorderColor'
                )}
              />
            </Box>
          </React.Fragment>
        ))}
      </Box>
    </Dialog>
  );
};

export default EditColorPopup;
